import React, {HTMLProps, PropsWithChildren} from 'react';
import {useFormContext} from 'react-hook-form';
import {RegisterOptions} from 'react-hook-form/dist/types/validator';
import {ReactComponent as CheckIcon24} from '@icons/Check.svg';
import clsx from 'clsx';
import inputStyles from '../Input/Input.module.scss';
import styles from './Checkbox.module.scss';

export type CheckboxProps = HTMLProps<HTMLInputElement> & PropsWithChildren<{
    forceHover?: boolean,
    validate?: RegisterOptions<any, any>,
    errorId?: string,
}>
export const Checkbox = ({
                             type,
                             children,
                             forceHover = false,
                             validate,
                             errorId,
                             ...props
                         }: CheckboxProps) => {
    const form = useFormContext();
    const name = props.name || '';
    const value = form.watch(name);
    const fieldError = form.formState.errors[name];
    const describedBy =
        fieldError && errorId
            ? [props['aria-describedby'], errorId].filter(Boolean).join(' ') || errorId
            : props['aria-describedby'];

    return <label className={clsx({
        [styles.disabled]: props.disabled,
        [styles.checked]: value || props.checked,
        [styles.hover]: forceHover,
    }, styles.checkBoxBox, inputStyles.Control)}>
        <input
            type="checkbox"
            className={clsx(styles.checkBoxInput, inputStyles.selectable)}
            {...props}
            {...form.register(name, validate)}
            aria-invalid={fieldError ? true : props['aria-invalid']}
            aria-describedby={describedBy}
        />
        <span className={styles.checkBox}>
            <CheckIcon24/>
        </span>
        <span>{children}</span>
    </label>;
};
